import React, { useState, useEffect } from "react";

import { NavLink, useNavigate } from "react-router-dom";

import translate from "../../../shared/utils/translations";
import FeatherIcon from "feather-icons-react";
import { Table, Tag, Dropdown, InputNumber, Button, Tooltip } from "antd";
import { FilterFilled } from "@ant-design/icons";
import EmptyIcon from "../../../../assets/img/empty.png";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";
import { requestHandler } from "../../../shared/utils/helpers";
import NoImage from "../../../../assets/img/no_image.png";

const CartItemsTable = ({ data, removeCartItem, refreshData }) => {
  let navigate = useNavigate();
  const [isTableSort, setTableSort] = useState(() => {
    const savedSort = localStorage.getItem("tableSort");
    return savedSort !== null ? savedSort : "list";
  });
  const [resetTrigger, setResetTrigger] = useState(false);

  const [filterValues, setFilterValues] = useState({
    roi: { min: undefined, max: undefined },
    sales_rank: { min: undefined, max: undefined },
    base_domain_converted_price: { min: undefined, max: undefined },
    target_domain_price: { min: undefined, max: undefined },
    monthly_sold: { min: undefined, max: undefined },
  });

  const getNumericColumnFilterProps = (dataIndex, title) => ({
    filterDropdown: ({ setSelectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: "15px" }}>
        <h6>{translate("Filter by")}</h6>
        <div className="fltt_bddy">
          <InputNumber
            placeholder={translate("Min")}
            value={filterValues[dataIndex]?.min}
            onChange={(value) =>
              setFilterValues((prev) => ({
                ...prev,
                [dataIndex]: { ...prev[dataIndex], min: value },
              }))
            }
            style={{ width: "100%" }}
          />
          <InputNumber
            placeholder={translate("Max")}
            value={filterValues[dataIndex]?.max}
            onChange={(value) =>
              setFilterValues((prev) => ({
                ...prev,
                [dataIndex]: { ...prev[dataIndex], max: value },
              }))
            }
            style={{ width: "100%" }}
          />
        </div>

        <div className="fltt__btnss">
          <Button
            type="primary"
            onClick={() => {
              setSelectedKeys([
                [filterValues[dataIndex]?.min, filterValues[dataIndex]?.max],
              ]);
              confirm();
            }}
            size="small"
            style={{ width: "100%" }}
          >
            {translate("Apply")}
          </Button>
          <Button
            onClick={() => {
              setFilterValues((prev) => ({
                ...prev,
                [dataIndex]: { min: undefined, max: undefined },
              }));
              setSelectedKeys([]);
              clearFilters();
            }}
            size="small"
            style={{ width: "100%" }}
          >
            {translate("Reset")}
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <FilterFilled style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      const [min, max] = value || []; // Directly get min and max from array
      const recordValue = record[dataIndex]; // Get the value for the current column

      if (min !== undefined && max !== undefined) {
        return recordValue >= min && recordValue <= max; // Filter between min and max
      } else if (min !== undefined) {
        return recordValue >= min; // Filter greater than or equal to min
      } else if (max !== undefined) {
        return recordValue <= max; // Filter less than or equal to max
      }
      return true; // If no filter is applied, return all records
    },
    render: (item) => <>{item}</>,
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  useEffect(() => {
    localStorage.setItem("tableSort", isTableSort);
  }, [isTableSort]);
  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const deleteItem = (id) => {
    Swal.fire({
      icon: "warning",
      title: translate("Are you sure?"),
      text: translate("Are you sure about performing this action?"),
      confirmButtonText: translate("Yes"),
      cancelButtonText: translate("Cancel"),
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        toast.success(translate("Your action was successful!"));
        removeCartItem(id);
      }
    });
  };

  const columns = [
    {
      title: translate("Image"),
      dataIndex: "image",
      key: "image",
      width: 150,
      minWidth: 100,
      render: (src) => (
        <>
          <img className="product-photo" src={src || NoImage} alt="" />
        </>
      ),
    },
    {
      title: "ASIN",
      dataIndex: "asin",
      key: "asin",
      width: 150,
      minWidth: 100,
      render: (item) => (
        <>
          <div className="column_info">ASIN</div>
          {item}
        </>
      ),
    },
    {
      title: translate("Title"),
      dataIndex: "title",
      key: "title",
      width: 200,
      minWidth: 100,
      render: (item) => (
        <>
          <div className="column_info">{translate("Title")}</div>
          {item?.length > 50 ? item.slice(0, 50) + "..." : item}
        </>
      ),
    },
    {
      title: translate("quantity"),
      dataIndex: "quantity",
      key: "quantity",
      width: 120,
      minWidth: 100,
      sorter: (a, b) => a.quantity - b.quantity,
      ...getNumericColumnFilterProps("quantity", "Quantity"),
      render: (item) => (
        <>
          <div className="column_info">{translate("Quantity")}</div>
          {item ? item : " - "}
        </>
      ),
    },
    {
      title: translate("Status"),
      key: "status",
      dataIndex: "status",
      width: 150,
      minWidth: 100,

      render: (item, record) => (
        console.log("record", record),
        (
          <>
            <div className="">{item}</div>
          </>
        )
      ),
    },
    {
      title: translate("Created / Updated date"),
      key: "created_at",
      dataIndex: "created_at",
      width: 150,
      minWidth: 100,

      render: (item, record) => (
        console.log("record", record),
        (
          <>
            <div className="">{new Date(item).toLocaleString()}</div>
            <div className="">
              {new Date(record.updated_at).toLocaleString()}
            </div>
          </>
        )
      ),
    },
    {
      title: translate("Action"),
      key: "action",
      width: 150,
      minWidth: 100,
      fixed: "right",
      className: "table_actin",
      render: (text, record) => (
        <>
          <div className="column_info">{translate("Details")}</div>

          <div className="flex_table_buttons new__fix">
            <Tooltip
              title={translate("Show Product Based Info")}
              placement="left"
            >
              <NavLink
                className={"pbi__link table_icon"}
                to={`/product-based-info/${record.asin}`}
                target="_blank"
              >
                <FeatherIcon icon={"package"} />
              </NavLink>
            </Tooltip>

            <Tooltip title={translate("Delete")} placement="top">
              <Button
                onClick={() => deleteItem(record.id)}
                icon={<FeatherIcon icon="trash" />}
                className={"table_icon"}
              />
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div
        className={`dif__ablee fav_Tbl_wrapper ${
          isTableSort === "list" ? " " : " block_m"
        }`}
      >
        <div className="merged___area"></div>
        <Table
          key={`${resetTrigger}-table__fvttsd`}
          columns={columns}
          rowSelection={rowSelection}
          dataSource={data?.map((item) => ({ ...item, key: item.id }))}
          pagination={{
            locale: {
              items_per_page: translate("Page"),
            },
            position: ["topRight", "bottomRight"],
          }}
          locale={{
            emptyText: (
              <span className="empty__tble">
                <img src={EmptyIcon} />
              </span>
            ),
          }}
          className="mob_bts cmp__table has_pag_btn rest_table favr_tbl"
        />
      </div>
    </>
  );
};

export default CartItemsTable;
